module.exports = __webpack_public_path__ + "coin_CHF.svg?d92728e92bfdd2ad0bf9dc52dc3c83c4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_CHF.svg
// module id = 1138
// module chunks = 2